import { WA } from "@/lib/whatsapp";
import { motion, useReducedMotion } from "framer-motion";
import { MessageCircle } from "lucide-react";

export const FloatingWhatsApp = () => {
  const reduce = useReducedMotion();
  return (
    <motion.a
      href={WA.general()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with DMS Wedding Films on WhatsApp"
      data-testid="floating-whatsapp-button"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.5 }}
      whileHover={reduce ? {} : { scale: 1.06 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_rgba(31,36,40,0.18)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2"
    >
      <MessageCircle className="h-7 w-7" aria-hidden="true" />
      <span className="sr-only">WhatsApp</span>
    </motion.a>
  );
};
